import ApiClient from './ApiClient';

class RecordingsAPI extends ApiClient {
  constructor() {
    super('recordings', { accountScoped: true });
  }

getRecordings(params = {}) {
  return axios.get(this.url, { params });
}
  getAudio(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}/audio`, {
      responseType: 'blob',
    });
  }

  download(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}/download`, {
      responseType: 'blob',
    });
  }
}

export default new RecordingsAPI();
